export default __webpack_public_path__ + "static/tech-uk-logo-af71fc8274084d987e4132e0a18aec01.svg";